module.exports = __webpack_public_path__ + "img/landing_box23.328b05d3.jpg";